<template>
  <article v-if="!isLogin" id='editlayout' class="center">
    <div class="g-signin2" data-onsuccess="onSignIn"></div>
    <Ubutton text="구글로그인" size="small" @click.native="login"/>
  </article>
  <article v-else class="contentMain">
    <EditTop :iconview="isFileName" :file="file" @save="saveHandler" @load="loadHandler" @logout="logout" @new="newHandler"/>
    <div v-if="!isFileName" id='editlayout' class="editstart">
      <div class="editstart-title">
        <span>UPENBE Edit 에 오신걸 환영합니다.</span>
      </div>
      <div class="editstart-body">
        <div>
          <icon size="ularge" uicon="223"/>
          <UInput type="text" placeholder="파일 이름을 입력해 주세요 (영문만,특문제외)" v-model="file.filename"/>
          <Ubutton text="시작하기" size="small" @click.native="isFileName = (file.filename !== '' && file.filename !== null && file.filename !== undefined)"/>
        </div>
        <span class="line"></span>
        <div>
          <icon size="ularge" uicon="224"/>
          <span>작업중인 파일 불러오기</span>
          <Ubutton text="불러오기" size="small" @click.native="loadHandler"/>
        </div>
      </div>
    </div>
    <div v-else id='editlayout' class="edit">
      <SectionEdit ref="elSection" :data.sync="sectionList" :count="option.totalcount" :trimcount="option.trimtotalcount" :initBody="option.initBody" firstElement="u_textEdit" @action="sectionAction"/>
      <section class="contentBody">
        <div class="contentTop">
          <ToolBar v-bind.sync="option" @action="toolAction"/>
          <Ubutton id="epub" class="epub" text="ePub2.0" size="small" state="active" @click.native="checkCreateEpub(false)"/>
          <Ubutton id="epubnot" class="epub" text="ePub2.0(연재)" size="small" state="active" @click.native="checkCreateEpub(true)"/>
        </div>
        <div class="postview">
          <FootNote :type="footnoteType" :data="footnotelist" :isShow.sync="footnoteShow" :editType.sync="option.type" @action="footnoteAction"/>
          <div id="postView" class="contentScorll">
            <div >
              <div id="canvas" class="hideContent">
                <TitleInput ref="elementTitle" v-model="title" :isReFocus.sync="option.isReFocus" :type.sync="option.type" :align="option.align"/>
                <!-- <div class="u_tag sectionline"><span class="section"></span></div> -->
                <span class="line"><span></span></span>
                <div id="addCover" class="inputData">
                  <span><icon size="xsmall" uicon="edit_check" :state="!coverinfo ? 'deactive' : 'active'"/></span>
                  <span>표지 <span class="require">*</span></span>
                  <Ubutton text="만들기" size="small" @click.native="openCoverPopup"/>
                </div>
                <span class="line"><span></span></span>
                <div id="addInfo" class="inputData">
                  <span><icon size="xsmall" uicon="edit_check" :state="!epubInfo ? 'deactive' : 'active'"/></span>
                  <span>서지정보 <span class="require">*</span></span>
                  <Ubutton text="만들기" size="small" @click.native="openInfoPopup"/>
                </div>
                <span class="line"><span></span></span>
                <Ueditor ref="elementEdit" v-bind.sync="option"/>
              </div>
            </div>
          </div>
          <IndexList :data="indexlistData" :initdata="indexlistInit" :isShow.sync="indexlistShow" :editType.sync="option.type" :range="option.range"/>
        </div>
      </section>
    </div>
    <umenu/>
    <popup/>
    <ucalendar/>
    <input type="file" class="hide" id="loadfile" accept=".up" @change="loadfile"/>
  </article>
</template>

<script>
import UInput from '@/components/base/UInput.vue'
import TitleInput from '@/components/edit/TitleInput.vue'
import EditTop from '@/components/edit/EditTop.vue'
import SectionEdit from '@/components/edit/SectionEdit.vue'
import FootNote from '@/components/edit/FootNote.vue'
import IndexList from '@/components/edit/IndexList.vue'
import Editor from '@/components/edit/Editor.vue'
import ToolBar from '@/components/edit/ToolBar.vue'
import ES from '@/components/js/EditorSetting.js'
import {closest} from '@/components/js/Utils.js'
// import {testbody, testImg, section, indexlist, indexlistinit, footnote} from '@/components/test/testimg.js'
import Epub from '@/components/js/Epub.js'

var epub = new Epub()

export default {
  props: {},
  created () {
  },
  mounted () {
    // console.log()
    // this.$store.commit('dev', true)
    console.log('mount', this.isLogin, sessionStorage.getItem('token'))
    console.log(process.env.NODE_ENV)
    if (sessionStorage.getItem('token') && this.isLogin === false) {
      this.$store.dispatch('checkLogin')
    }
  },
  beforeDestroy () {
    // this.$store.commit('dev', false)
  },
  data: function () {
    return {
      isFileName: false,
      file: {
        filename: null,
        fileid: null,
        drive: null,
        parent: null
      },
      title: '',
      coverinfo: null,
      epubInfo: null,
      isEpubInfo: true,
      sectionList: [],
      option: {
        range: null,
        type: ES.TYPE_TEXT,
        align: ES.ALIGN_LEFT,
        italic: false,
        underline: false,
        strike: false,
        isReFocus: false,
        bold: false,
        font: null,
        size: null,
        indent: false,
        foreColor: '#000000',
        backColor: '#FFFFFF',
        editStyle: null,
        initBody: null,
        link: null
      },
      footnotelist: [],
      footnoteShow: true,
      footnoteType: 'edit',
      indexlistData: [],
      indexlistInit: [],
      indexlistShow: true
    }
  },
  name: 'UpenbeEdit',
  watch: {
  },
  computed: {
  },
  methods: {
    signin () {
    },
    login () {
      // this.$gapi.signIn().then((a) => {
      //   console.log('signIn', a)
      // })
      switch (process.env.NODE_ENV) {
        case 'development' :
          window.location.replace('/api/auth/driveGoogle?dev=true')
          break
        default :
          window.location.replace('/api/auth/driveGoogle')
          break
      }
    },
    logout () {
      this.$store.dispatch('logOut')
      // this.$route.replace('/upenbeedit')
      // console.log(this.$router)
      // window.location.replace('/upenbeedit')
    },
    toolAction (optionName, cmd, value) {
      if (optionName) {
        this.option[optionName] = value
      }
      switch (this.option.type) {
        case ES.TYPE_TITLE :
          this.$refs.elementTitle.changeTool(cmd, value)
          break

        default :
          this.$refs.elementEdit.changeTool(cmd, value)
          break
      }
    },
    footnoteAction (action, value) {
      this.$refs.elementEdit.changeTool(ES.toolFOOTNOTE, value)
    },
    sectionAction (action, value) {
      switch (action) {
        case 'create' :
          this.$refs.elementEdit.changeTool(ES.toolSECTION, value)
          break
        case 'remove' :
          this.$refs.elementEdit.changeTool(ES.toolREMOVE, value)
          break
      }
    },
    imageChange (e) {

    },
    openInfoPopup () {
      this.openPopup('EpubInfo', {title: this.title, info: this.epubInfo}, (e) => {
        if (e.result) {
          this.epubInfo = e.param
          if (this.epubInfo !== null) {
            this.epubInfo.id = 'addInfo'
            this.epubInfo.isEdit = false
            this.epubInfo.name = '서지정보'
            this.element = document.querySelector('#addInfo')
            switch (this.indexlistInit.length) {
              case 0 :
                this.indexlistInit.push(this.epubInfo)
                break
              case 1 :
                if (this.indexlistInit[0].id === 'addInfo') {
                  this.$set(this.indexlistInit, 0, this.epubInfo)
                } else {
                  this.indexlistInit.push(this.epubInfo)
                }
                break
              case 2 :
                this.$set(this.indexlistInit, 1, this.epubInfo)
                break
            }
          } else {
            if (this.indexlistInit[0] && this.indexlistInit[0].id === 'addInfo') {
              this.indexlistInit.pop()
            } else if (this.indexlistInit[1]) {
              this.indexlistInit.pop()
            }
          }
        }
      })
    },
    openCoverPopup () {
      this.openPopup('CoverPopup', this.coverinfo, (e) => {
        if (e.result) {
          this.coverinfo = e.param
          if (this.coverinfo !== null) {
            this.coverinfo.id = 'addCover'
            this.coverinfo.element = document.querySelector('#addCover')
            switch (this.indexlistInit.length) {
              case 0 :
                this.indexlistInit.unshift(this.coverinfo)
                break
              case 1 :
                if (this.indexlistInit[0].id === 'addCover') {
                  this.$set(this.indexlistInit, 0, this.coverinfo)
                } else {
                  this.indexlistInit.unshift(this.coverinfo)
                }
                break
              case 2 :
                this.$set(this.indexlistInit, 0, this.coverinfo)
                break
            }
          } else {
            if (this.indexlistInit[0] && this.indexlistInit[0].id === 'addCover') {
              this.indexlistInit.unshift()
            }
          }
        }
      })
    },
    createSection (bodycopy) {
      var secList = []
      var footnote = []
      var b = bodycopy.querySelector('.u_textEdit')
      var f = b.firstChild
      var l = b.lastChild
      var kk = l.lastChild
      // var imgFile = []
      this.sectionList.forEach((n, i) => {
        var r = document.createRange()
        var tem
        switch (i) {
          case 0 :
            r.setStart(f.firstChild, 0)
            if (this.sectionList.length > 1) {
              tem = bodycopy.querySelector('#' + this.sectionList[i + 1].id)
              r.setEnd(tem.lastChild, tem.lastChild.length)
            } else {
              // r.setEnd(l.lastChild, l.lastChild.length)
              console.log(l.lastChild)
              console.log(l.lastChild.nodeName)
              console.log(l.lastChild.nodeType)
              if (l.lastChild.nodeName === 'BR') {
                kk = kk.parentNode
                l.removeChild(l.lastChild)
                console.log(kk)
                console.log(kk.lastChild)
                console.log(kk.lastChild.nodeName)
                console.log(kk.lastChild.nodeType)
              }
              switch (l.lastChild.nodeType) {
                case 3 :
                  r.setEnd(l.lastChild, l.lastChild.length)
                  break
                case 1 :
                  while (kk.lastChild.nodeType !== 3) {
                    if (kk.lastChild.nodeName === 'BR') {
                      kk = kk.previousSibling
                    } else {
                      kk = kk.lastChild
                    }
                  }
                  r.setEnd(kk.lastChild, kk.lastChild.length)
                  break
              }
            }
            break
          default :
            if ((this.sectionList.length - 1 !== i && bodycopy.querySelector('#' + n.id).nextSibling === bodycopy.querySelector('#' + this.sectionList[i + 1].id).previousSibling) || (this.sectionList.length - 1 === i && bodycopy.querySelector('#' + n.id).nextSibling === l)) {
              r.selectNode(bodycopy.querySelector('#' + n.id).nextSibling)
            } else {
              r.setStart(bodycopy.querySelector('#' + n.id).nextSibling, 0)
              if (this.sectionList.length - 1 === i) {
                console.log(l.lastChild)
                console.log(l.lastChild.nodeType)
                if (l.lastChild.nodeName === 'BR') {
                  kk = kk.parentNode
                  l.removeChild(l.lastChild)
                  console.log(kk)
                  console.log(l.lastChild)
                  console.log(kk.lastChild)
                }
                if (l.lastChild) {
                  switch (l.lastChild.nodeType) {
                    case 3 :
                      r.setEnd(l.lastChild, l.lastChild.length)
                      break
                    case 1 :
                      while (kk.lastChild.nodeType !== 3) {
                        kk = kk.lastChild
                      }
                      r.setEnd(kk.lastChild, kk.lastChild.length)
                      break
                  }
                } else {
                  r.setEnd(l, 0)
                }
              } else {
                tem = bodycopy.querySelector('#' + this.sectionList[i + 1].id).previousSibling
                console.log('lastChild', tem)
                console.log('lastChild', tem.lastChild)
                console.log(tem.lastChild.length)
                r.setEnd(tem.lastChild, tem.lastChild.length)
              }
            }
            break
        }
        var k = r.cloneContents()
        console.log('createSection', r.cloneContents())
        if (r.cloneContents().querySelector(ES.ENTER) === null) {
          console.log(closest(r, ES.ENTER))
          var rs = document.createElement(ES.ENTER)
          var rss = [...new Set(k.childNodes)]
          rss.forEach((n) => {
            console.log(n.nodeName)
            if (n.nodeName === 'H2') {
              k.appendChild(n)
            } else {
              rs.appendChild(n)
              k = new DocumentFragment()
              k.appendChild(rs)
            }
          })
        }
        console.log('createSection', r.cloneContents().querySelector(ES.ENTER))
        console.log('createSection', k.lastChild)
        var temp = []
        k.querySelectorAll('a').forEach((fi) => {
          console.log(fi)
          temp.push(this.footnotelist.find((fn) => fn.id === fi.id))
        })
        secList.push(k)
        footnote.push(temp)
      })
      console.log(footnote)
      return {sec: secList, foot: footnote}
    },
    createNotEpub (bo) {
      epub.title = this.title
      epub.creator = this.epubInfo.creator
      epub.illustrator = this.epubInfo.illustrator
      epub.dsr = this.epubInfo.dsr
      epub.publisher = this.epubInfo.publisher
      epub.addr = this.epubInfo.addr
      epub.email = this.epubInfo.email
      epub.date = this.epubInfo.date
      epub.isbn = this.epubInfo.isbn
      epub.setIsbn = this.epubInfo.setIsbn
      epub.cover = this.coverinfo.img
      epub.coverName = this.coverinfo.name
      var bodycopy = document.createRange()
      bodycopy.selectNode(document.querySelector('.u_textEdit'))
      var o = this.createSection(bodycopy.cloneContents())
      epub.sectionList = o.sec
      epub.footnotelist = o.foot
      epub.indexList = this.indexlistData
      epub.isEpubInfo = !bo
      epub.create((f) => {
        this.openPopup('DriveList', {type: 'epub', file: this.file, body: f}, (e) => {
          console.log(e)
        })
      })
    },
    checkCreateEpub (bo) {
      if (this.coverinfo && this.coverinfo.img) {
        this.checkEpub(bo)
      } else {
        this.confirm({
          target: '표지가 등록되어 있지 않습니다.',
          message: '표지가 없는 상태로 책을 만드시겠습니까?',
          icon: '107',
          require: true
        }, (e) => {
          console.log(e)
          if (e.result) {
            this.checkEpub(bo)
          }
        })
      }
    },
    checkEpub (bo) {
      console.log('checkEpub', this.epubInfo)
      if (this.epubInfo) {
        this.createNotEpub(bo)
      } else {
        this.alert({
          target: '서지정보가 등록되어 있지 않습니다.',
          message: '서지정보는 필수로 등록되어야 합니다.',
          icon: '107',
          require: true
        })
      }
    },
    saveHandler () {
      var ob = {
        title: this.title,
        section: this.sectionList,
        footnote: this.footnotelist,
        indexinit: this.indexlistInit,
        indexlist: this.indexlistData,
        body: document.querySelector('.u_textEdit').innerHTML.replace(/<o:p><\/o:p>/gim, ''),
        epubinfo: this.epubInfo,
        cover: this.coverinfo
      }
      // var b = new Blob([JSON.stringify(ob)], {type: 'text/plain;charset=utf-8'})
      this.openPopup('DriveList', {type: 'save', file: this.file, body: ob}, (e) => {
        if (e.result) {
          this.file.fileid = e.param.id
          this.file.filename = e.param.name
          this.file.drive = e.param.drive
          this.file.parent = e.param.parent
        }
      })
      // FileServer.saveAs(b, this.filename + '.up')
    },
    newHandler () {
      this.isFileName = false
      this.file.fileid = ''
      this.file.filename = ''
      // this.file.drive = null
      // this.file.parent = null
      this.$set(this.option, 'initBody', '')
      this.sectionList = []
      this.footnotelist = []
      this.indexlistInit = []
      this.indexlistData = []
      this.epubInfo = null
      this.coverinfo = null
      this.title = ''
      this.option.align = 'left'
    },
    loadHandler () {
      // document.querySelector('#loadfile').click()
      this.openPopup('DriveList', {type: 'load', file: this.file}, (e) => {
        if (e.result) {
          console.log(e)
          this.file.fileid = e.param.id
          this.file.filename = e.param.name
          this.file.drive = e.param.drive
          this.file.parent = e.param.parent
          var ob = JSON.parse(e.param.body)
          var d = document.createElement('div')
          ob.body = ob.body.replace(/if(.*?)endif/gim, '').replace(/<!--(.*?)-->/gim, '&nbsp;')
          ob.body = ob.body.replace(/<o:p><\/o:p>/gim, '')
          ob.body = ob.body.replace(/\s+&nbsp;\s+/gim, '&nbsp;')
          d.innerHTML = ob.body
          while (d.querySelector('.u_textEdit')) {
            var c = document.createElement('div')
            c.innerHTML = d.querySelector('.u_textEdit').innerHTML
            d = c
          }
          d.innerHTML = d.innerHTML.replace(/..\/Text\/footnote.xhtml/gim, '')
          console.log(d)
          console.log('load check', d.querySelector('.u_textEdit'))
          this.$set(this.option, 'initBody', d.innerHTML)
          this.sectionList = ob.section
          this.footnotelist = ob.footnote
          this.indexlistInit = ob.indexinit
          this.indexlistData = ob.indexlist
          this.epubInfo = ob.epubinfo
          this.coverinfo = ob.cover
          this.title = ob.title
          this.isFileName = true
        }
      })
    },
    loadfile (e) {
      console.log(e.target.files[0].name)
      if (e.target.files[0]) {
        this.filename = e.target.files[0].name.split('.')[0]
        var fr = new FileReader()
        fr.onload = (fe) => {
          var st = fe.target.result
          // console.log(st)
          var ob = JSON.parse(st)
          // console.log(ob)
          this.$set(this.option, 'initBody', ob.body)
          this.sectionList = ob.section
          this.footnotelist = ob.footnote
          this.indexlistInit = ob.indexinit
          this.indexlistData = ob.indexlist
          this.epubInfo = ob.epubinfo
          this.coverinfo = ob.cover
          this.title = ob.title
          this.isFileName = true
          document.querySelector('#loadfile').value = null
          setTimeout(() => {
            this.$set(this.option, 'initBody', null)
          })
        }
        fr.readAsText(e.target.files[0])
      }
    }
  },
  components: {
    'Ueditor': Editor,
    'ToolBar': ToolBar,
    'FootNote': FootNote,
    'EditTop': EditTop,
    'SectionEdit': SectionEdit,
    'IndexList': IndexList,
    'TitleInput': TitleInput,
    UInput
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/earlyaccess/nanumgothic.css');
@import url('https://fonts.googleapis.com/earlyaccess/nanummyeongjo.css');
@import url('https://cdn.jsdelivr.net/font-kopub/1.0/kopubdotum.css');
@import url('https://fonts.googleapis.com/earlyaccess/kopubbatang.css');
:root {
  --bg-default: #F9F9F9;
  --bg-white: #FFFFFF;

  --line-title: #404040;
  --line-base: #7f7f7f;
  --line-guide: #bfbfbf;

  --text-title: #404040;
  --text-base: #7f7f7f;
  --text-guide: #bfbfbf;

  --active: #00b0f0;
  --require: #c00000;
  --deactive: #7f7f7f;
  --disable: #EAEAEA;

  --button-type0: var(--active);
  --button-type1: var(--require);
  --button-type2: var(--deactive);
  --button-disable: var(--disable);

  --icon-base: #404040;
  --icon-over: #000000;
  --icon-active: var(--active);
  --icon-require: var(--require);
  --icon-disable: var(--disable);
  --icon-deactive: var(--text-guide);

  --bookW: 290px;
  --bookH: 250px;
  --bookWS: 30px;
  --bookHS: 40px;
  --postW: 400px;
  --postH: 140px;
  --postWS: 30px;
  --postHS: 40px;
}
body {
  margin:0px auto;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  word-break: break-all;
  color: var(--text-base);
}
*:focus {
  outline: none;
}
a {
  text-decoration: none;
  white-space: nowrap;
}
a:hover {

}
a:focus{
  outline: none;
}
.rotate90 {
  transform: rotate(90deg);
}
.rotate180 {
  transform: rotate(180deg);
}
.rotate270 {
  transform: rotate(270deg);
}
input:focus,
textarea:focus {
  outline: none;
}
input::placeholder,
textarea::placeholder {
  color: var(--text-guide);
}
textarea {
  border: 0px;
  width: 100%;
  height: 100%;
  resize: none;
}
input[type=text], input[type=password] {
  flex: 1;
  border: 0px;
  padding: 0px 0px 0px 0px;
  height: 100%;
  width: 100%;
  background-color: inherit;
  font-size: 1em;
}
input[type=checkbox].checkbox {
  display: none;
}
input[type=checkbox].checkbox + label {
  position: relative;
  display: inline-block;
  padding-left: 20px;
  cursor: pointer;
}
input[type=checkbox].checkbox + label::before {
  content: '';
  color: var(--line-base);
  position: absolute;
  line-height: 13px;
  width: 13px;
  height: 13px;
  border-radius:3px;
  border: 1px solid var(--line-base);
  left: 0px;
  text-align: center;
}
input[type=checkbox].checkbox:checked + label::before {
  content: '\2714';
}
#upenbe {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.whiteStyle {
  background-color: white;
  color: black;
}
.cursorButton {
  cursor:pointer;
}
.contentScorll {
  overflow-y: auto;
  overflow-x: hidden;
}
* {
  box-sizing: border-box;
}
ul {
  margin: 0px;
  padding: 0px;
}
a:visited {
  text-decoration: none;
  color: #0000EE;
}
button {
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid;
  padding: 0px;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
button.active {
  color: var(--active);
  border-color: var(--active);
}
button.active:hover {
  color: var(--bg-white);
  background-color: var(--active);
}
button.deactive {
  color: var(--deactive);
  border-color: var(--deactive);
}
button.deactive:hover {
  color: var(--bg-white);
  background-color: var(--deactive);
}
button.in-deactive {
  color: var(--bg-white);
  background-color: var(--line-title);
}
button.require {
  color: var(--require);
  border-color: var(--require);
}
button.require:hover {
  color: var(--bg-white);
  background-color: var(--require);
}
button.disable {
  color: var(--disable);
  border-color: var(--disable);
}
button.toogle.true {
  color: var(--bg-white);
  background-color: var(--active);
}
button.toogle.false {
  border: 1px solid var(--line-base);
  color: var(--text-base);
}
button.toogle.false:hover {
  background-color: var(--line-base);
  color: var(--bg-white);
}
.active {
  color: var(--active);
}
.guide {
  color: var(--text-guide);
}
.title {
  color: var(--text-title);
}
.require {
  color: var(--require);
}
.disable {
  color: var(--disable);
}
.highlight {
  color: var(--bg-white);
}
#layout {
  width: 100%;
  height: calc(100vh - 55px);
  display: inline-flex;
  flex-direction: row;
}
.Book + .Book {
  margin-left: var(--bookWS);
}
.Book {
  margin-bottom: var(--bookHS);
}
.Post + .Post {
  margin-left: var(--postWS);
}
.Post {
  margin-bottom: var(--postHS);
}
.genreStep {
  margin: 0 0px;
}
/* ------------------------------------------------------------------------- */
@media only screen and (max-width: 630px) {
  .leftOffBookListContent {
    width: var(--bookW);
  }
  .leftOffBookListContent .Book:nth-child(1n) {
    margin-left: 0px;
  }
}
@media only screen and (min-width: 631px) and (max-width: 950px) {
  .leftOffBookListContent {
    width: calc(var(--bookW) * 2 + var(--bookWS));
  }
  .leftOffBookListContent .Book:nth-child(2n+1) {
    margin-left: 0px;
  }
}
@media only screen and (min-width: 951px) and (max-width: 1270px) {
  .leftOffBookListContent {
    width: calc(var(--bookW) * 3 + var(--bookWS) * 2);
  }
  .leftOffBookListContent .Book:nth-of-type(3n+1) {
    margin-left: 0px;
  }
}
@media only screen and (min-width: 1271px) and (max-width: 1590px) {
  .leftOffBookListContent {
    width: calc(var(--bookW) * 4 + var(--bookWS) * 3);
  }
  .leftOffBookListContent .Book:nth-of-type(4n+1) {
    margin-left: 0px;
  }
}
@media only screen and (min-width: 1591px) {
  .leftOffBookListContent {
    width: calc(var(--bookW) * 5 + var(--bookWS) * 4);
  }
  .leftOffBookListContent .Book:nth-of-type(5n+1) {
    margin-left: 0px;
  }
}
/* ------------------------------------------------------------------------- */
@media only screen and (max-width: 920px) {
  .leftOnBookListContent {
    width: var(--bookW);
  }
  .leftOnBookListContent .Book:nth-child(1n) {
    margin-left: 0px;
  }
}
@media only screen and (min-width: 921px) and (max-width: 1230px) {
  .leftOnBookListContent {
    width: calc(var(--bookW) * 2 + var(--bookWS));
  }
  .leftOnBookListContent .Book:nth-child(2n+1) {
    margin-left: 0px;
  }
}
@media only screen and (min-width: 1231px) and (max-width: 1560px) {
  .leftOnBookListContent {
    width: calc(var(--bookW) * 3 + var(--bookWS) * 2);
  }
  .leftOnBookListContent .Book:nth-of-type(3n+1) {
    margin-left: 0px;
  }
}
@media only screen and (min-width: 1561px) {
  .leftOnBookListContent {
    width: calc(var(--bookW) * 4 + var(--bookWS) * 3);
  }
  .leftOnBookListContent .Book:nth-of-type(4n+1) {
    margin-left: 0px;
  }
}
/* ------------------------------------------------------------------------- */
@media only screen and (max-width: 830px) {
  .leftOffPostListContent {
    width: var(--postW);
  }
}
@media only screen and (min-width: 830px) and (max-width: 1260px) {
  .leftOffPostListContent {
    width: calc(var(--postW) * 2 + var(--postWS));
  }
}
@media only screen and (min-width: 1260px) {
  .leftOffPostListContent {
    width: calc(var(--postW) * 3 + var(--postWS) * 2);
  }
}
@media only screen and (max-width: 1120px) {
  .leftOnPostListContent {
    width: var(--postW);
  }
  .leftOnPostListContent .Post:nth-child(1n) {
    margin-left: 0px;
  }
}
@media only screen and (min-width: 1120px) and (max-width: 1550px) {
  .leftOnPostListContent {
    width: calc(var(--postW) * 2 + var(--postWS));
  }
  .leftOnPostListContent .Post:nth-child(2n+1) {
    margin-left: 0px;
  }
}
@media only screen and (min-width: 1550px) {
  .leftOnPostListContent {
    width: calc(var(--postW) * 3 + var(--postWS) * 2);
  }
  .leftOnPostListContent .Post:nth-child(3n+1) {
    margin-left: 0px;
  }
}
#content {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--bg-default);
}
#content > div:first-child {
  height: 100%;
}
#content .inputShow {
  height: calc(100% - 190px);
}
.content {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  height: 100%;
}
.scrollContent {
  overflow-y: auto;
}
.hideLeft {
  width: 100vw;
}
.showLeft{
  width: calc(100vw - 290px);
}
.hide {
  display: none !important;
}
.show {
  display: flex;
}
.list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 30px;
}
</style>
<style scoped>
#editlayout {
  width: 100%;
  height: calc(100vh - 55px);
}
#editlayout.edit {
  display: inline-flex;
  flex-direction: row;
}
.center {
  display: flex;
  width: 100%;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
}
.editstart {
  display: flex;
  flex-direction: column;
}
.editstart > div {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.editstart-title {
  height: 20%;
  font-size: 30px;
  font-weight: bold;
}
.editstart-body {
  height: 80%;
}
.editstart-body > div {
  display: flex;
  width: 50%;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  line-height: 80px;
}
.editstart-body > div .input {
  margin: 30px 0px;
  width: 290px;
}
.editstart-body > .line {
  border-left: 1px solid var(--line-guide);
  height: 70%;
}
.contentBody {
  position: relative;
  display: flex;
  flex-direction: column;
  width: calc(100vw - 290px);
}
.canvas {
  width: 100%;
  flex-direction: column;
}
#canvas > span.line {
  display: flex;
  align-items: center;
  width: 100%;
  height: 30px;
}
#canvas > span.line > span {
  width: 100%;
  border-bottom: 1px dashed var(--require);
}
#canvas > span.line > span::after {
  content: 'SECTION';
  position: absolute;
  left: 50%;
  color: var(--require);
  background-color: var(--bg-white);
  font-size: 10px;
  padding: 0px 5px;
  /* top: 50%; */
  transform: translateX(-50%) translateY(-50%);
}
.postview {
  position: relative;
  height: calc(100% - 40px);
  display: flex;
  flex-direction: row;
  background-color: #F9F9F9;
  padding-top: 10px;
}
#postView {
  position: relative;
  width: 100%;
  min-height: 100%;
  flex: 1;
}
#postView > div {
  position: relative;
  width: 700px;
  background-color: var(--bg-white);
  border-top: 1px solid var(--line-guide);
  border-left: 1px solid var(--line-guide);
  box-shadow: 2px 2px 3px 0px var(--line-guide);
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 0px auto;
  min-height: calc(100vh - 55px - 90px);
  padding-top: 20px;
}
.contentTop {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-right: 10px;
  border-bottom: 1px solid var(--line-guide);
}
.epub {
  height: 25px;
}
#epubnot {
  width: 140px;
  margin-left: 10px;
}
.inputData {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  height: 80px;
  padding: 0px 10px 0px 10px;
}
.inputData button {
  flex: none;
  margin-left: auto;
}
.inputData span:first-child {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/router/page/upenbeEdit.vue